<template>
  <div id="press" class="bg-white w-50 position-fixed sticky-bottom end-0 m-1 border rounded border-component overflow-hidden shadow-lg">
    <div class="row g-0 p-1 bg-success-subtle text-success" :style="[enabled ? '' : 'filter: invert(1) grayscale(100%) brightness(200%)']">
      <div class="col fs-20"><img src="/waffle.png" style="width:20px" alt="Waffle - Press"/> Waffle - Press</div>
      <div class="col-auto">
        <button class="border-0 rounded-circle cursor-pointer" @click="enabled=!enabled">{{ enabled ? "&minus;" : "&plus;" }}</button>
      </div>
    </div>
    <div v-for="(section, sectionName) in data" :key="sectionName" :class="{'d-none': !enabled}">
      <div class="row g-0 align-items-center p-1 bg-secondary-subtle border-top border-component">
        <div class="col fw-bold cursor-pointer" @click="opened=opened===sectionName?null:sectionName">{{ opened === sectionName ? '&minus;' : '&plus;' }} {{ sectionName }}</div>
        <template v-if="section.flatMap(s => s.steps).length">
          <div class="col-auto fs-12 mx-1 p-2 position-relative rounded-circle border">
            <span class="text-center position-absolute top-0 start-0 w-100">{{ section.flatMap(s => s.steps).filter(s => !s.result).length }}</span>
          </div>
          <div class="col-auto fs-12 mx-1 p-2 position-relative rounded-circle text-bg-success">
            <span class="text-center position-absolute top-0 start-0 w-100">{{ section.flatMap(s => s.steps).filter(s => s.result === 'pass').length }}</span>
          </div>
          <div class="col-auto fs-12 mx-1 p-2 position-relative rounded-circle text-bg-danger">
            <span class="text-center position-absolute top-0 start-0 w-100">{{ section.flatMap(s => s.steps).filter(s => s.result === 'fail').length }}</span>
          </div>
          <span class='col-auto play d-inline-block align-middle mx-1 position-relative' :class="{'pause':section.running}" @click="runSection(sectionName, section)">
            <span class='play d-inline-block align-middle position-absolute pe-none' style="top:-.5em;left:-.5em" :class="{'d-none':section.running}"></span>
          </span>
        </template>
      </div>
      <div v-if="opened === sectionName" class="px-1 overflow-y-scroll" style="max-height:13em">
        <div v-for="(review, review_idx) in section" :key="review_idx" class="my-2">
          <div class="row g-1 align-items-center">
            <div class="col fw-bold">
              {{ review_idx + 1 }}) {{ review.name }}...
              <span v-if="review.baseDomain" :title="'Imported from ' + review.baseDomain">&#9432;</span>
            </div>
            <template v-if="review.steps.length">
              <div class="col-auto fs-12 mx-1 p-2 position-relative rounded-circle border">
                <span class="text-center position-absolute top-0 start-0 w-100">{{ review.steps.filter(s => !s.result).length }}</span>
              </div>
              <div class="col-auto fs-12 mx-1 p-2 position-relative rounded-circle text-bg-success">
                <span class="text-center position-absolute top-0 start-0 w-100">{{ review.steps.filter(s => s.result === 'pass').length }}</span>
              </div>
              <div class="col-auto fs-12 mx-1 p-2 position-relative rounded-circle text-bg-danger">
                <span class="text-center position-absolute top-0 start-0 w-100">{{ review.steps.filter(s => s.result === 'fail').length }}</span>
              </div>
              <span class='col-auto play d-inline-block align-middle mx-1' :class="{'pause':review.running}" @click="runReview(sectionName, review)"></span>
            </template>
          </div>
          <div v-if="review.steps.length" class="border p-1">
            <div v-for="(step, step_idx) in review.steps" :key="step_idx" class="row g-1 align-items-center">
              <div class="col">{{ review_idx + 1 }}.{{ step_idx + 1 }} ...{{ step.desc }}</div>
              <div class="col-auto">
                <div class="fs-20" :title="step.assert">&#9874;</div>
              </div>
              <div class="col-auto">
                <div v-if="step.running" class="spinner-border spinner-border-sm"></div>
                <div v-else class="p-2 rounded-circle" :class="[step.result==='pass'?'bg-success':step.result==='fail'?'bg-danger':'border']"></div>
              </div>
            </div>
          </div>
          <div v-else class="px-1 border p-1">- no reviews configured -</div>
        </div>
      </div>
    </div>
    <div class="d-none p-1 bg-warning-subtle border-top border-component">
      TODO: status of tests in a multi-color segmented progress bar
    </div>
  </div>
</template>
<script>
export default {
  name: 'Press',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      enabled: true,
      opened: null
    }
  },
  methods: {
    awaitTimeout: delay => new Promise(resolve => setTimeout(resolve, delay)),
    async runSection(sectionName, section) {
      if (section.running) {
        console.error('already running section', section);
        return;
      }
      section.running = true;
      for (const review of section)
        await this.runReview(sectionName, review);
      section.running = false;
    },
    async runReview(sectionName, review) {
      if (review.running) {
        console.error('already running review', review);
        return;
      }
      review.running = true;
      review.steps.forEach(step => step.result = null);
      //TODO: replace with test-runner (off the shelf or homegrown?)
      if (!window.jQuery) {
        var script = document.createElement('script');
        script.src = "https://code.jquery.com/jquery-3.7.1.slim.min.js";
        document.getElementsByTagName('head')[0].appendChild(script);
        await this.awaitTimeout(1000);
      }
      for (const step of review.steps) {
        step.running = true;
        await this.awaitTimeout(Math.random() * 789);
        let result;
        try {
          result = eval(step.assert);
        } catch (e) {
          console.error('Error in step [%s] %o', e, step);
          result = false;
        }
        step.result = result ? 'pass' : 'fail';
        console.info('%cREVIEW: %c%s%c [%s] %s %s',
            'background:#fed9b7;color:black;padding:3px;border-radius:5px 0 0 5px;',
            'background:#' + (result ? '198754' : 'dc3545') + ';color:white;padding:3px;', step.result,
            'background:#fed9b7;color:black;padding:3px;border-radius:0 5px 5px 0', sectionName, review.name, step.desc);
        step.running = false;
      }
      review.running = false;
    }
  }
}
</script>
<style lang="scss">
.play {
  background: transparent;
  box-sizing: border-box;
  width: 0;
  height: 1em;

  border-color: transparent transparent transparent green;
  transition: 100ms all ease;
  cursor: pointer;

  // play state
  border-style: solid;
  border-width: .5em 0 .5em 1em;

  &.pause {
    border-style: double;
    border-width: 0 0 0 1em;
    border-color: orange;
  }
}
</style>